import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["golfLifeVideoWrapper"]

  connect() {
    document.addEventListener("keydown", this.hideHandler.bind(this))
  }

  disconnect() {
    document.removeEventListener("keydown", this.hideHandler.bind(this))
  }

  hideHandler(event) {
    if (event.keyCode == 27) {
      this.hide(event)
    }
  }

  show(event) {
    event.preventDefault()
    this.golfLifeVideoWrapperTarget.classList.add("show")
  }

  hide(event) {
    event.preventDefault()
    this.pauseVideo()
    this.golfLifeVideoWrapperTarget.classList.remove("show")
  }

  pauseVideo() {
    const overlay = document.querySelector("#golf-life-video-overlay-wrapper")

    const video = overlay.querySelector("video")

    if (video) {
      video.pause()
    }
  }
}
